import React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_COACHING_DASHBOARD_SCHEDULE_INSTANCES_QUERY from 'coaching/queries/GetCoachDashboardScheduleInstances.gql';
import {
  GetCoachDashboardScheduleInstances,
  GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach,
} from 'coaching/queries/__generated__/GetCoachDashboardScheduleInstances';

export type Props = {
  startDateTime: string;
  endDateTime: string;
  children: (props: {
    coachingDashboardScheduleInstances?: GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachingScheduleContainer(props: Props) {
  const { startDateTime, endDateTime } = props;
  return (
    <Query<GetCoachDashboardScheduleInstances>
      query={GET_COACHING_DASHBOARD_SCHEDULE_INSTANCES_QUERY}
      variables={{ startDateTime: startDateTime, endDateTime: endDateTime }}>
      {({ loading, error, data }) => {
        return props.children({
          coachingDashboardScheduleInstances: data?.coaching_coachingSessionInstancesForCoach,
          loading,
          error,
        });
      }}
    </Query>
  );
}
